module.exports = __webpack_public_path__ + "2a9ac3f8ca481e8f328ce9e4a04a8c2d.svg";